// ** Redux Imports
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

// ** Import server Config
import apiLink from '@configs/serverConfig'

// ** Axios Imports
import axios from 'axios'

// ** Haul
export const getHaulList = createAsyncThunk('appHaul/getHaulList', async params => {
   params.page = params.page === 0 ? 0 : params.page - 1    
   const response = await axios.post(apiLink('getHaulList'), params)        
   return {
      params,
      data: response.data.content,
      totalPages: response.data.totalElements
   }
})
export const getHaul = createAsyncThunk('appHaul/getHaul', async id => {
   const response = await axios.get(apiLink({name: 'getHaul', value: id}))
   return response.data
})
export const addHaul = createAsyncThunk('appHaul/addHaul', async (data) => {
   const response = await axios.post(apiLink('addHaul'), data)
   return response.data
})
export const updateHaul = createAsyncThunk('appHaul/updateHaul', async (data) => {
   const id = data.id
   delete data.id
   const response = await axios.put(apiLink({name: 'updateHaul', value: id}), data)
   return response.data
})

export const finishHaul = createAsyncThunk('appHaul/finishHaul', async (id) => {
   const response = await axios.put(apiLink({name: 'finishHaul', value: id}))
   return response.data
})
export const removeHaul = createAsyncThunk('appHaul/removeHaul', async (id) => {
   const response = await axios.delete(apiLink({name: 'removeHaul', value: id}))
   return response.data
})

export const addHaulExpense = createAsyncThunk('appHaul/addHaulExpense', async (data) => {
   const id = data.id
   delete data.id
   const response = await axios.post(apiLink({name: 'addHaulExpense', value: id}), data)
   return response.data
})
export const removeHaulExpense = createAsyncThunk('appHaul/removeHaulExpense', async ({haul_id, expense_id}) => {
   const response = await axios.delete(apiLink({name: 'removeHaulExpense', values: [haul_id, expense_id]}))
   return response.data
})
export const addHaulFuel = createAsyncThunk('appHaul/addHaulFuel', async (data) => {
   const id = data.id
   delete data.id
   const response = await axios.post(apiLink({name: 'addHaulFuel', value: id}), data)
   return response.data
})
export const removeHaulFuel = createAsyncThunk('appHaul/removeHaulFuel', async ({haul_id, fuel_id}) => {
   const response = await axios.delete(apiLink({name: 'removeHaulFuel', values: [haul_id, fuel_id]}))
   return response.data
})


// ** Payments
export const addPayment = createAsyncThunk('appHaul/addPayment', async (data) => {
   return await axios.post(apiLink('addPayment'), data)
})
export const removeHaulPayment = createAsyncThunk('appHaul/removeHaulPayment', async (id) => {
   const response = await axios.delete(apiLink({name: 'removePayment', value: id}, {type: 'HAUL'}))
   return response.data
})

// Media files
export const getMedia = createAsyncThunk('appHaul/getMedia', async ({haul_id, types}) => {
   const response = await axios.post(apiLink('getFiles', {typeOwner: 'HAUL'}), {
      ids: [haul_id],
      types
   })
   return {files: response.data.files, haul_id}
})
export const addMedia = createAsyncThunk('appHaul/addMedia', async ({haul_id, type, typeOwner, file}) => {
   const response = await axios({
        method: "post",
        url: apiLink({name: 'uploadFile', value: haul_id}, {type, typeOwner}),
        data: { file },
        headers: { "Content-Type": "multipart/form-data" }
      })
   return response.data
})
export const removeMedia = createAsyncThunk('appHaul/removeMedia', async (id) => {
   const response = await axios.delete(apiLink({name: 'removeFile', value: id}, {typeOwner: 'HAUL'}))
   return {id, status: response.status}
})

// ** Customers list
export const getHaulCustomers = createAsyncThunk('appHaul/getHaulCustomers', async () => {
   const params = {active: true, sort_list: 'first_name', sort_order: 'ASC', rows: 1000, blacklist: false}
   const response = await axios.get(apiLink('getCustomersShortList', params))
   return response.data.customers
})
// ** Cars list
export const getHaulCars = createAsyncThunk('appHaul/getHaulCars', async () => {
   const params = {sort_list: 'id', sort_order: 'ASC', rows: 1000, statuses: 'BASE', has_customer: false, in_road_accident_lock: false}
   const response = await axios.get(apiLink('getCarsShortList', params))
   return response.data.cars
})

// ** Report
export const getHaulReport = createAsyncThunk('appHaul/getHaulReport', async data => {
   const response = await axios.post(`https://api.mfauto.com.ua/haul/report?env=${process.env.REACT_APP_NODE_ENV}`, data)
   return response.data
})

// ** Unique params
export const getUniqueHaulParams = createAsyncThunk('appHaul/getUniqueHaulParams', async data => {
   const response = await axios.post(`https://api.mfauto.com.ua/haul/get/unique/params?env=${process.env.REACT_APP_NODE_ENV}`, data)
   return response.data
})

export const appHaulSlice = createSlice({
  name: 'appHaul',
  initialState: {
    data: [],
    total: 1,
    params: {},
    selectedHaul: null,
    customers: [],
    media: []
  },
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(getHaulList.fulfilled, (state, action) => {
         state.data = action.payload.data
         state.params = action.payload.params
         state.total = action.payload.totalPages
      })
      .addCase(getHaul.fulfilled, (state, action) => {
         state.selectedHaul = action.payload
      })
      .addCase(getMedia.fulfilled, (state, action) => {
         const uniqueMedia = [...state.media, ...action.payload.files].reduce((accumulator, current) => {
            if (!accumulator.find((item) => item.file_id === current.file_id)) {
               accumulator.push(current)
            }
            return accumulator
         }, [])
         state.media = uniqueMedia.filter((item) => item.haul_id === action.payload.owner_id)
      })
      .addCase(removeMedia.fulfilled, (state, action) => {
         if (action.payload.status === 200) {
            state.media = state.media.filter(item => item.file_id !== action.payload.id)
         }
      })     
  }
})

export default appHaulSlice.reducer
